const autoNgTemplateLoaderTemplate1 = require('./coach-edit.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.coachEdit', [])
        .component('coachEdit', {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'CoachEditController',
            controllerAs: 'vm'
        })
        .config(coachEditConfig);

    coachEditConfig.$inject = ['$routeProvider'];

    function coachEditConfig($routeProvider) {
        $routeProvider
            .when('/nutrition/coach-edit/:id', {
                disableCache: true,
                template: '<coach-edit></coach-edit>',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Coach Edit', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
                    ]
                }
            })
            .when('/scan-iq/coach-edit/:id', {
                disableCache: true,
                template: '<coach-edit></coach-edit>',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.SCAN_IQ,
                    breadcrumbs: [
                        { label: 'Coach Edit', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
                    ]
                }
            })
    }
})();
